import axios from "axios";
import store from "../store";
import { authActions } from "../store/auth";
import { grnActions } from "../store/grn";
import { getSSOToken, logoutSSO } from "../utils/ssoHelper";

let tokenRefreshPromise = null;

const DEFAULT_CONFIG = {
  headers: {
    "content-type": "application/json",
  },
};

const setUpConfig = (isAuthenticated, token = "") => {
  if (isAuthenticated) {
    return {
      headers: {
        "content-type": "application/json",
        authorization: token ? token : localStorage.getItem("user_token"),
      },
    };
  } else {
    return DEFAULT_CONFIG;
  }
};

const refreshSSOToken = () => {
  // Several requests can fail together when the token expires. Reuse one SSO
  // refresh so they cannot race and overwrite auth state with different data.
  if (!tokenRefreshPromise) {
    tokenRefreshPromise = getSSOToken().finally(() => {
      tokenRefreshPromise = null;
    });
  }

  return tokenRefreshPromise;
};

const get = async (URL, isAuthenticated = false, getFullResult = false) => {
  try {
    const CONFIG = setUpConfig(isAuthenticated);
    const result = await axios.get(URL, CONFIG);
    if (getFullResult) {
      return result?.data?.body;
    } else {
      return result.data;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
};

const post = async (
  URL,
  PAYLOAD = {},
  isAuthenticated = false,
  getFullResult = false
) => {
  try {
    store.dispatch(grnActions.updateLambdaErr(false));

    const TOKEN = store.getState()?.auth?.token;
    const CONFIG = setUpConfig(isAuthenticated, TOKEN);

    const result = await axios.post(URL, PAYLOAD, CONFIG);

    if (result?.data?.status === "invalid") {
      store.dispatch(authActions.clearAuth());
      await logoutSSO();
      return false;
    }

    return getFullResult ? result?.data?.body : result?.data;
  } catch (e) {
    const status = e?.response?.status;

    if (status === 401 && isAuthenticated) {
      try {
        const newTokenData = await refreshSSOToken();

        if (newTokenData?.token) {
          localStorage.setItem("user_token", newTokenData.token);

          store.dispatch(
            authActions.setSSOLogin({
              token: newTokenData.token,
              // Some SDK versions return user fields at the top level, while
              // others nest them under `user`. The reducer also preserves any
              // fields omitted from a refresh response.
              user: newTokenData.user || newTokenData,
            })
          );

          const retryConfig = setUpConfig(true, newTokenData.token);
          const retryResult = await axios.post(URL, PAYLOAD, retryConfig);

          if (retryResult?.data?.status === "invalid") {
            store.dispatch(authActions.clearAuth());
            await logoutSSO();
            return false;
          }

          return getFullResult
            ? retryResult?.data?.body
            : retryResult?.data;
        }

        store.dispatch(authActions.clearAuth());
        await logoutSSO();
        return false;
      } catch (refreshErr) {
        console.log("SSO refresh failed:", refreshErr);
        store.dispatch(authActions.clearAuth());
        await logoutSSO();
        return false;
      }
    }

    store.dispatch(grnActions.updateLambdaErr(true));
    return false;
  }
};

export const tokenExpiry = (status) => {
  return !(status === "error" || status === "success" || status === "validation_error" || status === "invalid");
};


export { post, get };
